<template>
  <div>
    <swiper :items="items"></swiper>
  </div>
</template>
<script>
  import swiper from '../components/swiper/swiper'
  export default {
    data () {
      return {
        items: [
          {url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_00664.png'},
          {url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_31895.png'},
          {url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_21528.png'},
          {url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_11148.png'}
        ]
      }
    },
    components: {
      swiper
    }
  }
</script>



// WEBPACK FOOTER //
// test.vue?68798313